<template>
  <div class="swiper-conter">
    <swiper ref="mySwiper" :options="swiperOptions">
      <swiper-slide v-for="(item, index) in titleList" :key="index">
        <span class="text">{{ item.Title }}</span>
        <a class="veitc" v-show="item.Href" target="_blank" :href="item.Href"
          >了解更多
        </a>
      </swiper-slide>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
export default {
  name: "headerSwiper",
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    titleList: Array,
  },
  data() {
    return {
      swiperOptions: {
        direction: "vertical",
        loop: true,
        speed: 500,
        mousewheelControl: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 5000,
        },
        observeParents: true,
        observer: true,
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.swiper.slideTo(0, 1000, true);
    });
  },
};
</script>
<style lang="scss" scoped>
@import "@css/style.scss";
.swiper-container {
  height: 67px;
  .swiper-slide {
    overflow: hidden;
  }
}
.text {
  display: inline-block;
  padding-right: 10px;
  max-width: 200px;
  min-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  height: 67px;
  line-height: 70px;
}
a.veitc {
  position: relative;
  overflow: hidden;
  display: inline-block;
  font-size: 14px;
  font-weight: 500;
  color: #639dff;
  padding: 11px;
  height: 67px;
  line-height: 70px;
  padding: 0;
  text-decoration: none;
}
a.veitc:after {
  content: ">";
  overflow: hidden;
  font-family: "swiper-icons";
  font-size: var(--swiper-navigation-size);
  text-transform: none !important;
  letter-spacing: 0;
  text-transform: none;
  font-variant: initial;
  line-height: 1;
  font-size: 13px;
}
</style>
